<app-breadcrumb
  [title]="page_name"
  [breadcrumb]="page_name"
  [currentUrl]="currentUrl"
></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <div class="account-sidebar" (click)="ToggleDashboard()">
          <a hre="javascript:void(0)" class="popup-btn">
            {{ "Profile" | translate }}
          </a>
        </div>
        <div class="dashboard-left" [class.open]="openDashboard">
          <div class="collection-mobile-back" (click)="ToggleDashboard()">
            <span class="filter-back">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
              {{ "Back" | translate }}
            </span>
          </div>
          <div class="block-content">
            <ul>
              <li>
                <a data-lng="es" [routerLink]="'/pages/dashboard'">
                  {{ "address" | translate }}
                </a>
              </li>
              <li class="active">
                <a data-lng="es" [routerLink]="'/pages/my-orders'">
                  {{ "orders" | translate }}
                </a>
              </li>
              <li>
                <a data-lng="es" [routerLink]="'/pages/my-coupones'">
                  {{ "coupones" | translate }}
                </a>
              </li>
              <li>
                <a data-lng="es" [routerLink]="'/pages/browse-log'">
                  {{ "browse log" | translate }}
                </a>
              </li>
              <li>
                <a data-lng="es" [routerLink]="'/pages/profile'">
                  {{ "my profile" | translate }}
                </a>
              </li>
              <li>
                <a
                  data-lng="es"
                  href="javascript:void(0)"
                  (click)="userLogOut()"
                >
                  {{ "logout" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="dashboard-right">
          <div class="dashboard">
            <!-- <div class="page-title table_hed">
                            <h2>{{page_name}}</h2>
                        </div> -->

            <div class="box-head">
              <h2>{{ page_name }}</h2>
            </div>

            <div class="loader-block" *ngIf="!datadone">
              <img src="assets/images/loader.gif" />
            </div>

            <div *ngIf="datadone">
              <div class="order-details-layout">
                <div class="single-item-text-block">
                  <span class="single-item-label">
                    {{ "Order ID" | translate }}:
                  </span>
                  <span class="single-item-text">
                    # {{ orderDetails?.count_invoice_type }}
                  </span>
                </div>
                <div class="single-item-text-block">
                  <span class="single-item-label">
                    {{ "order date" | translate }}:
                  </span>
                  <span class="single-item-text">
                    {{ orderDetails?.date_added | date : "d-M-y h:mm a" }}
                  </span>
                </div>
                <div class="single-item-text-block">
                  <span class="single-item-label">
                    {{ "order status" | translate }}:
                  </span>
                  <span class="single-item-text">
                    {{
                      orderDetails?.status == "pending"
                        ? ("pending" | translate)
                        : (orderDetails.status | translate)
                    }}
                  </span>
                </div>
                <div
                  class="single-item-text-block"
                  *ngIf="orderDetails.payment_method_name"
                >
                  <span class="single-item-label">
                    {{ "payment way" | translate }}:
                  </span>
                  <span class="single-item-text">
                    {{ orderDetails.payment_method_name }}
                  </span>
                </div>
                <div
                  class="single-item-text-block"
                  *ngIf="orderDetails.shipment_company"
                >
                  <span class="single-item-label">
                    {{ "shipping way" | translate }}:
                  </span>
                  <span class="single-item-text">
                    {{ orderDetails.shipment_company }}
                  </span>
                </div>
              </div>

              <!-- ADDRESS SECTION -->
              <div
                class="box-account box-info"
                *ngIf="orderDetails.shipment_company"
              >
                <div class="box-head">
                  <h2>{{ "shipping address" | translate }}</h2>
                </div>
                <div
                  class="address-block"
                  *ngIf="orderDetails.shipping_type == 'my_address'"
                >
                  <div class="single-item-text-block">
                    <span class="single-item-label">
                      {{ "City" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails?.city_name }}
                    </span>
                  </div>
                  <div
                    class="single-item-text-block"
                    *ngIf="orderDetails?.district_name"
                  >
                    <span class="single-item-label">
                      {{ "District" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails?.district_name }}
                    </span>
                  </div>
                  <div class="single-item-text-block">
                    <span class="single-item-label">
                      {{ "Address" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails?.address }}
                    </span>
                  </div>
                </div>
              </div>
              <!-- ORDER SUMMARY SECTION -->
              <div class="box-account box-info">
                <div class="box-head">
                  <h2>{{ "order summary" | translate }}</h2>
                </div>
                <div class="address-block">
                  <div class="single-item-text-block">
                    <span class="single-item-label">
                      {{ "retail price" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.sup_total_price }}
                    </span>
                  </div>
                  <div
                    class="discount-block"
                    *ngIf="+orderDetails.discount > 0"
                  >
                    <span class="single-item-label">
                      {{ "Discounts" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.discount | number }}
                    </span>
                  </div>

                  <div
                    class="discount-block"
                    *ngIf="+orderDetails.quantity_discount > 0"
                  >
                    <span class="single-item-label">
                      {{ "Enjoy the quantitative discount" | translate }}
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.quantity_discount | number }}
                    </span>
                  </div>
                  <div
                    class="discount-block"
                    *ngIf="orderDetails.coupon_discount > 0"
                  >
                    <span class="single-item-label">
                      {{ "coupon discount" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.coupon_discount | number }}
                    </span>
                  </div>
                  <div
                    class="discount-block"
                    *ngIf="orderDetails.total_offer_discount > 0"
                  >
                    <span class="single-item-label">
                      {{ "offer-discount" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.total_offer_discount | number }}
                    </span>
                  </div>
                  <div
                    class="single-item-text-block"
                    *ngIf="
                      parseFloat(orderDetails.coupon_discount) +
                        parseFloat(orderDetails.discount) +
                        parseFloat(orderDetails.quantity_discount) +
                        parseFloat(orderDetails.total_offer_discount) >
                      0
                    "
                  >
                    <span class="single-item-label">
                      {{ "sale price" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{
                        parseFloat(orderDetails.sup_total_price) -
                          (parseFloat(orderDetails.coupon_discount) +
                            parseFloat(orderDetails.discount) +
                            parseFloat(orderDetails.quantity_discount) +
                            parseFloat(orderDetails.total_offer_discount))
                      }}
                    </span>
                  </div>

                  <div
                    class="single-item-text-block"
                    *ngIf="+orderDetails.payment_method_price > 0"
                  >
                    <span class="single-item-label">
                      {{ "payment cost" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.payment_method_price | number }}
                    </span>
                  </div>

                  <div
                    class="single-item-text-block"
                    *ngIf="orderDetails.additional_value > 0"
                  >
                    <span class="single-item-label">
                      {{ "shipping cost" | translate }}:
                    </span>
                    <span class="single-item-text">
                      {{ orderDetails.additional_value }}
                    </span>
                  </div>
                  <div class="single-item-text-block" style="font-weight: bold">
                    <span class="" style="font-weight: bold">
                      {{ "Total-final" | translate }}:
                    </span>
                    <span class="single-item-text" style="font-weight: bold">
                      {{ orderDetails.total_price }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- PRODUCTS SECTION -->
              <div class="box-account box-info">
                <div class="box-head">
                  <h2>{{ "products" | translate }}</h2>
                </div>

                <div class="products-list-layout">
                  <app-product-item-checkout [products]="order_products">
                  </app-product-item-checkout>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- section end -->

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
  <div class="shadow login-sidebar">
    <i class="ti-close login-icon" (click)="close()"></i>
    <app-fast-login
      (step5Reached)="onStep5Reached()"
      (stepSuccessReached)="onstepSuccessReached()"
    ></app-fast-login>
  </div>
</section>
